import React, { useState } from "react";
import {
  Typography,
  Container,
  Paper,
  Box,
  TextField,
  Button,
} from "@mui/material";

const TermsAndCondition = () => {
  const [signature, setSignature] = useState("");

  const handleSignatureChange = (e) => {
    setSignature(e.target.value);
  };

  const handleAcceptClick = () => {
    // Handle the acceptance logic here
    //console.log(`User accepted with signature: ${signature}`);
    console.log("");
  };

  return (
    <Container style={{ textAlign: "justify",paddingTop: "20px" }}>
      <Typography variant="h3"style={{ textAlign: "center"}} >
        KAIZEN DIGITAL® OFFICE END USER AGREEMENT
      </Typography>

      <Typography variant="body1">
        IMPORTANT — READ CAREFULLY: This End-User Agreement ("Agreement") is a
        legal contract between you (“End User” or “You”) and KAIZEN DIGITAL
        Healthcare, Inc. (“Company”), the owners of the KAIZEN DIGITAL® Office
        software that will be accessed and used by you as part of Products
        and/or Service made available to you through an Affiliated Organization
        that has a Master Agreement in place with Company (“Client”). This
        Agreement is separate and distinct from the Master Agreement in place
        between Client and Company. If You are also the Client, then in addition
        to agreeing to the terms and conditions set forth below You are also
        agreeing to the terms of the Master Agreement.
      </Typography>

      <Box mt={2} mb={2}>
        <Typography variant="h6" style={{ fontWeight: "bold" }}>
          END USER AFFIRMS ITS UNDERSTANDING THAT:
        </Typography>
      </Box>
      <Paper elevation={3} variant="outlined">
        <Box p={2}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            <ul><li> ACCESS AND USE TO THE KAIZEN DIGITAL OFFICE SOLUTION AND ANY OTHER
            PRODUCTS AND SERVICES PROVIDED THEREWITH, IS THROUGH THE AFFILIATED
            ORGANIZATION AND CLIENT AND NOT DIRECTLY FROM COMPANY.
            </li></ul>
          </Typography>
        </Box>
      </Paper>

      <Paper elevation={3} variant="outlined">
        <Box p={2}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            <ul>
            <li> ANY WRITTEN OR ORAL UNDERSTANDING ENTERED BETWEEN END USER AND THE
            AFFILIATED ORGANIZATION AND/OR CLIENT SPEAKING TO THE ACCESS AND USE
            OF ANY COMPANY-PROVIDED PRODUCT AND/OR SERVICE UNDER THIS AGREEMENT
            IS BETWEEN THE AFFILIATED ORGANIZATION, CLIENT, AND END USER ONLY;
            COMPANY IS NOT A PARTY THERETO.
            </li>
            </ul>
          </Typography>
        </Box>
      </Paper>

      <Paper elevation={3} variant="outlined">
        <Box p={2}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            <ul><li>
            CERTAIN OF ITS RIGHTS AND BENEFITS UNDER THIS AGREEMENT MAY BE
            MODIFIED BY THE AFFILIATED ORGANIZATION AND/OR CLIENT, INCLUDING BUT
            NOT LIMITED TO, RIGHT TO ACCESS AND USE THE CLIENT DATA ENTERED
            AND/OR CREATED BY END USER THROUGH THE KAIZEN DIGITAL OFFICE
            SOLUTION AND ANY OTHER PRODUCTS AND SERVICES PROVIDED THEREWITH.
            </li></ul>
          </Typography>
        </Box>
      </Paper>

      <Paper elevation={3} variant="outlined">
        <Box p={2}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            <ul><li> CLIENT AND/OR THE AFFILIATED ORGANIZATION, NOT COMPANY, WILL BE
            PROVIDING END USER ANY NEEDED, SET UP, TRAINING OR MAINTENANCE
            SERVICES UNDER THIS AGREEMENT.
            </li></ul>
          </Typography>
        </Box>
      </Paper>

      <Paper elevation={3} variant="outlined">
        <Box p={2}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            <ul><li> TERMINATION OF THE MASTER AGREEMENT IN PLACE BETWEEN CLIENT AND
            COMPANY CONTEMPORANEOUSLY TERMINATES END USER’S ACCESS AND USE OF
            THE PRODUCTS AND SERVICES. END USER ITSELF HAS NO INDEPENDENT RIGHT
            OF ACCESS AND USE OF THE PRODUCTS AND SERVICES UNDER THIS AGREEMENT.
            </li></ul>
          </Typography>
        </Box>
      </Paper>

      <Paper elevation={3} variant="outlined">
        <Box p={2}>
          {/* <Typography variant="body1" style={{ fontWeight: "bold" }}>
            <ul><li> BY CLICKING THE [ENTER] OR [ACCEPTED] ICON BELOW, OR OTHERWISE
            USING THE PRODUCTS AND SERVICES PROVIDED, INCLUDING BUT NOT LIMITED
            TO THE KAIZEN DIGITAL OFFICE SOLUTION AND ANY CLEARINGHOUSE
            SERVICES, YOU AGREE TO BE BOUND BY THE TERMS OF THIS AGREEMENT.
            </li></ul>
          </Typography> */}
        </Box>
      </Paper>
      {/* <TextField
        label="Your Signature"
        variant="outlined"
        size="small"
        margin="normal"
        value={signature}
        onChange={handleSignatureChange}
        style={{ marginBottom: '26px' }}
      /> */}

      {/* <Button
        sx={{ mt: 2 }}
        variant="contained"
        color="primary"
        onClick={handleAcceptClick}
      >
        Accept
      </Button> */}

      <Typography variant="h5">
        IF YOU DO NOT AGREE TO THE TERMS OF THIS AGREEMENT, DO NOT ACCESS OR USE
        THE PRODUCTS AND/OR SERVICES PROVIDED OR INSTALL ANY PLUG-IN SOFTWARE
        (IF ANY) ASSOCIATED THEREWITH, AND EXIT NOW.
      </Typography>

      <Typography variant="body1">
        PLEASE REVIEW THIS AGREEMENT EVERY TIME YOU USE THE NGO OFFERING (AS
        DEFINED BELOW) AS THERE MAY BE CHANGES AND UPDATES FROM TIME TO TIME. DO
        NOT USE THIS WEBSITE OR ANY COMPANY SERVICE OR PRODUCT FOR A MEDICAL
        EMERGENCY. IF YOU ARE A CONSUMER AND YOU HAVE AN URGENT, IMMEDIATE OR
        EMERGENCY, CONTACT YOUR HEALTHCARE PROVIDER OR CALL 911 OR THE LOCAL
        EMERGENCY NUMBER IMMEDIATELY. IF YOU ARE A PROVIDER AND NEED TO CONTACT
        A PAYOR IN AN EMERGENCY, DO SO DIRECTLY BY TELEPHONE OR OTHER MEANS
      </Typography>

      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>1. Authorized User.</strong>
        {"\t"}
        You affirm that you are:
        <br />
        (i) authorized by Client, or an Affiliated Organization of such Client,
        to use and access the KAIZEN DIGITAL® Office solution and/or other
        Products and Services made available to you by Client (“NGO Offering”)
        <br />
        (ii) based in the United States, or
        <br />
        (iii) are an authorized member of a community using the NGO Offering for
        purposes of health information exchange or care coordination.
        <br />
        Unless specifically stated otherwise in the applicable User Material,
        you will be assigned a unique ID and password by Client.
      </Typography>

      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>2. User Account/Access.</strong>
        {"\t"}
        To use the NGO Offerings and any Clearinghouse Services or other
        services specifically made available to you by the Affiliated
        Organization through Client, and for each such Service to operate
        properly, End User must supply Client with certain enrollment and
        registration data (“Registration Data”), all of which must be accurate
        and updated as appropriate. Failure to properly maintain the
        Registration Data shall be a breach of the Agreement. End User should
        ensure that it can receive e-mail from Company and Client, which may
        require End User to add Company to a “trusted” sender list to avoid
        delays or having Company’s correspondences blocked from End User’s
        inbox. End User acknowledges that Client or the applicable Affiliated
        Organization, not Company, is responsible for providing End User with
        the requisite IDs and passwords to access any of the Services. End User
        acknowledges that any termination of this Agreement or the Master
        Agreement or the relationship between End User and the Affiliated
        Organization and/or with Client, regardless of cause, will halt End
        Users’ access and use of the Products and Services (including any data
        that may be accessible only through Product and Services) and Company
        shall not be liable for any damages to End User and/or any patient
        caused by the inaccessibility.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>3. No License. </strong>
        {"\t"}
        End User acknowledges that no license to any Company Technology is being
        provided to it but rather End User is solely being provided through the
        Affiliated Organization through Client the use and access of Company
        Technology through the NGO Offering. However, certain NGO Offering may
        require End User to install on its equipment Plug-In software to access
        and use the NGO Offering. Subject to End User’s compliance with the
        terms of this Agreement and solely as it relates to such Plug-In
        Software, Company has granted Client, during the Service Term, a
        non-transferable and non-exclusive license to (A) permit End User to
        access the NGO Offering through the applicable interfaces solely for
        their internal operations and (B) install, use and implement Plug-In
        Software solely for use by End User to access and use the NGO Offering
        as permitted under this Agreement. End User must take steps to prevent
        unauthorized access to its login IDs and passwords
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>4. End User’s Responsibilities</strong>
        {"\t"}
        End User hereby grants Company all consents, authorization and approvals
        necessary to enable Company to perform its obligations under this
        Agreement as well as the Master Agreement. Company has no responsibility
        to identify, evaluate or assist End User in End User’s decision to
        participate in any Special Program. End User is solely responsible for
        determining whether to participate in such opportunities. Company is not
        required to take or refrain from taking any action relating to or
        arising from such Special Program, except as otherwise set forth in an
        Order Form, Statement of Work, or Schedule entered between Company and
        Client.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>5. Professional Diagnosis and Treatment</strong>
        {"\t"}
        Products and Services made available through the NGO Offering do not
        make clinical, medical or other professional decisions, and are not
        substitutes for End User applying professional judgment and analysis.
        End User is solely responsible for (A) verifying the accuracy of all
        information and reports produced by or through the NGO Offering (B)
        obtaining necessary consents for use and disclosure of patient
        information; (C) determining data necessary for decision-making by End
        User and its Personnel; and (D) making all diagnoses and treatments and
        determining compliance, and complying, with all Laws and licensing
        requirements for the operation of End User’s business. Company is not
        responsible for: (A) ensuring that any Providers (i) have active
        professional licenses and any other credentials required for the
        provision of services by them, (ii) are not suspended from providing
        services and (B) performing reasonable credentialing activities to
        ensure that Providers are authorized and suitable for providing services
        pursuant to applicable Law or otherwise.{" "}
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>6. Limitations on Use</strong>
        {"\t"}
        End User will not: (A) sell, transfer, lease, assign, or sublicense any
        NGO Offering; (B) use any NGO Offering as a service bureau, for
        outsourcing, for sharing access to any NGO Offering with any Third Party
        (except for authorized End Users), or for otherwise offering or making
        available the functionality of the NGO Offeringto any Third Party; (C)
        permit any End User or other person to access or use NGO Offering using
        another End User’s ID, login or password or otherwise make an End User’s
        ID, login or password available to any Third Party; (D) use any NGO
        Offering to process anything other than End User’s data; (E) bypass any
        privacy and/or security measures Company may use to prevent or restrict
        access to the NGO Offering (or other accounts, computer systems or
        networks connected to the Company’s Products or Services); (F) knowingly
        use the NGO Offering in a manner that violates any applicable local,
        state, national and foreign laws, treaties or regulations (including
        those related to data privacy, international communications, export laws
        and the transmission of technical or personal data laws); or (G) remove
        any intellectual property, confidentiality or proprietary notices of
        Company and/or any Third-Party which appear in any form on or in the NGO
        Offering or otherwise in any Company collateral or materials however
        reproduced.{" "}
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>7. No Use or Disclosure of Confidential Information. </strong>
        {"\t"}
        End User will only use Confidential Information for the purposes of this
        Agreement and will not reproduce, disseminate, or disclose Confidential
        Information to any Third Party, except to its employees and authorized
        representatives (i.e., temporary employees, consultants, and
        contractors) who need to know the Confidential Information for the
        purposes of this Agreement and are bound by confidentiality obligations
        at least as restrictive as those in this section. End User will treat
        all Confidential Information with at least the same degree of care as it
        treats its own information of similar sensitivity, but never with less
        than reasonable care. End User shall immediately notify Company of any
        breaches of security that result in or are likely to result in
        disclosure of Company’s Confidential Information. However, End User may
        disclose Confidential Information: (A) as approved in a writing signed
        by Company (B) as is required by law, (C) is about adverse events,
        hazards and other unsafe conditions made to governmental agencies,
        health care accreditation organizations and/or patient safety
        organizations; (D) is about cybersecurity threats and incidents made to
        government agencies; (E) is about information blocking and other
        unlawful practices to a government agency; (F) communicating information
        about Company’s failure to comply with a Condition of Certification or
        Other Program Requirements.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>8. Personal Information. </strong>
        {"\t"}
        Notwithstanding anything in the Agreement to the contrary, End User will
        not submit any Personally Identifiable Information (“PII”), Individually
        Identifiable Information (“IIHI”) and/or Protected Health Information
        (“PHI”) directly to Company under this Agreement. All End User data is
        to be provided to the Affiliated Organization and/or Client for the
        Affiliated Organization and/or Client’s use with the NGO Offering on
        behalf of End User, under the terms of the Master Agreement. End User
        acknowledges that any obligations under a Business Associate Agreement
        for any Services runs between Company and Client only and Company has no
        obligations thereunder directly to the Affiliated Organization and/or
        the End User. .
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>9. Patient Data/De-Identified Data. </strong>
        {"\t"}
        End User acknowledges that as among Company, Client, Affiliated
        Organization and End User, the Affiliated Organization owns the Client
        Data residing within the NGO Offering and that Client and/or the
        Affiliated Organization control the terms and conditions associated with
        End User’s rights and access to any data residing within the NGO
        Offering, including but not limited to any Protected Health Information
        and/or Individually Identifiable Health Information. Company may
        De-Identify Client Data before such data is incorporated into any
        Analytics Database. De-Identified Data will be aggregated with
        de-identified data from enough other customers in a manner reasonably
        designed to prevent Company or others from using the Analytics Databases
        to analyze the characteristics of End User’s business. End-User grants
        Company a non-exclusive, worldwide, paid-in-full, perpetual and
        irrevocable right and license to: (A) extract, copy, aggregate, process
        and create derivative works of Client Data to derive, or add to,
        Analytics Databases; (B) employ data analytics on the Analytics
        Databases for purposes of developing Data Analytics solutions; and (C)
        prepare derivative works of the Analytics Databases, and use, execute,
        reproduce, display, perform, transfer, distribute, and sublicense the
        Analytics Databases and such derivative works. Company will not
        individually identify End-User as a source of the De-Identified Data for
        the Analytics Databases, although Company may disclose that certain of
        its customers allow the use of Client Data for such purposes.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>10. Compliance. </strong>
        {"\t"}
        EEnd User represents and warrants that:
        <br />
        (A) it, and its Personnel are not under or subject to a “Corporate
        Integrity Agreement” or any other restriction or investigation by any
        payer, government agency or industry self-regulating organization;
        <br />
        (B) neither it nor any of its affiliates, directors or Personnel are (a)
        listed on the General Services Administration’s Excluded Parties List
        System or (b) suspended or excluded from participation in any Government
        Payer Programs; and
        <br />
        (C) there are no pending or threatened governmental investigations
        against End User or any of its affiliates, directors or Personnel that
        may lead to suspension or exclusion from Government Payer Programs or
        may be cause for listing on the General Services Administration’s
        Excluded Parties List System.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>
          11. eLearning Materials Subscription/Training Materials.{" "}
        </strong>
        <br />
        {"\t"}
        For certain NGO Offering, as part of certain required Company training
        thereon: (A) a subscription through Client for access by End User to
        Company’s “eLearning” online training materials (the “eLearning
        Materials”) may be included in the NGO Offering fee paid for by Client
        on behalf of End User. Company provides eLearning Materials only for
        online access by End User for the sole purpose of learning how to access
        and use the NGO Offering. End User may not make any copies or download
        any of the eLearning Materials unless such materials expressly state
        otherwise. End User must have its own subscription and use its own ID
        and password to access eLearning Materials; and/or
        <br />
        (B) use of printed materials (as may be provided during onsite training
        sessions) and/or electronic materials (available for download for remote
        training sessions) may be required. Company owns all such materials and
        all such materials are for End User’s own use. End User may not make any
        copies of these materials unless such materials expressly state
        otherwise.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>12. Proprietary Rights. </strong>
        {"\t"}. Company and its licensors own the Company Technology that is
        used in the NGO Offering. Outside of the access and use rights provided
        to End User from Client or the Affiliated Organization, End User obtains
        no individual right to access and use the NGO Offering nor to any
        Company Technology used therein. End User has no right to use Company’s
        or any Third Party’s name, trademarks or logo, or any goodwill now or
        hereafter associated therewith, all of which is the sole property of and
        will inure exclusively to the benefit of Company or such Third Party.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>13. No Modifications </strong>
        {"\t"}
        End User may not modify, create derivative works of, adapt, translate,
        reverse engineer the NGO Offering or otherwise decompile, disassemble or
        attempt to discover the source code or any other non-user facing aspects
        in any NGO Offering. Breach of this section will be deemed a material
        breach of this Agreement and entitle Company to immediately terminate
        this Agreement
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>14. Feedback. </strong>
        {"\t"}
        The purpose of this section is to avoid potential misunderstandings or
        disputes when Company’s products and/or marketing strategies might seem
        like ideas submitted or feedback given by End User to Company. By
        submitting any Feedback, <br />
        (1) Company will be free to use, disclose, reproduce, license or
        otherwise distribute, and exploit such Feedback as Company sees fit,
        without any obligation or restriction of any kind to End User;<br></br>{" "}
        (2) there is no obligation for End User to give, or Company to review,
        Feedback; and
        <br />
        (3) there is no obligation to keep any Feedback confidential.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>
          15. Disclaimer of Warranty and Limitation of Liability.{" "}
        </strong>
        {"\t"}
        THE NGO OFFERING, AS WELL AS ANY COMPANY TECHNOLOGY RESIDING THEREIN, IS
        PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT ANY WARRANTY (WHETHER
        EXPRESS OR IMPLIED - INCLUDING BUT NOT LIMITED TO ANY WARRANTY OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE OR
        NON-INFRINGEMENT) OR ANY OTHER LIABILITY TO COMPANY, INCLUDING WITHOUT
        LIMITATION, NO LIABILITY FOR CONSEQUENTIAL, INDIRECT, CONTINGENT, OR
        SPECIAL DAMAGES, LOST PROFITS FOR SEQUENCE, ACCURACY OR COMPLETENESS OF
        DATA OR THAT IT WILL MEET THE END USER’S REQUIREMENTS, EVEN IF COMPANY
        OR ANY OF ITS REPRESENTATIVES HAVE BEEN ADVISED OF THE POSSIBILITY OF
        SUCH DAMAGES, OR FOR ANY CLAIM BY ANY THIRD PARTY. END USER ASSUMES THE
        ENTIRE RISK OF USING THE NGO OFFERING AND ANY COMPANY TECHNOLOGY
        THEREIN. IN NO EVENT, SHALL COMPANY BE LIABLE TO END USER OR TO ANY
        THIRD PARTY FOR ANY SPECIAL, INDIRECT, CONSEQUENTIAL OR CONTINGENT
        DAMAGES INCLUDING LOSS OF PROFITS, EVEN IF COMPANY HAS BEEN ADVISED OF
        THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING LIMITATIONS SHALL APPLY
        WHETHER IN AN ACTION BASED ON CONTRACT, TORT OR ANY OTHER THEORY.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>16. Dispute Resolution and Arbitration. </strong>
        {"\t"}
        Any dispute, claim, or controversy arising out of or relating to this
        Agreement, including the determination of the scope or applicability of
        this clause, will be determined exclusively in the State of Delaware by
        binding arbitration before a single arbitrator mutually agreed to by the
        parties. The arbitration shall be administered by JAMS pursuant to its
        Comprehensive Arbitration Rules and Procedures. There shall be no right
        to arbitrate on a class action basis or on behalf of the general public
        or other group of persons similarly situated. Each party will be
        responsible for its own attorneys' fees and shall split the costs of
        arbitration. The arbitrator shall have authority to apportion costs
        (other than attorneys' fees) at the end of any such proceeding. Judgment
        on any award may be entered in any court having jurisdiction. Nothing in
        this clause shall preclude parties from seeking provisional remedies in
        aid of arbitration from a court of appropriate jurisdiction.
      </Typography>
      <Typography variant="body1" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>17. Entire Agreement. </strong>
        {"\t"}
        This Agreement is a companion to the Master Agreement in place with
        Client. As between End User and Company:
        <br />
        (i) contains the entire understanding between the parties with respect
        to the subject matter set forth herein, and neither party is relying on
        any representations or warranties other than those found in the
        Agreement,
        <br />
        (ii) supersedes all prior and contemporaneous negotiations, agreements,
        contracts, commitments and understandings, both verbal and written,
        between the parties, and
        <br />
        (iii) does not operate as an acceptance of any conflicting terms or
        conditions and shall prevail over any conflicting provisions of any
        purchase order, request for proposal, request for information or any
        other instrument. End User understands that the headings used in the
        Agreement are solely for convenience of reference and are not intended
        to have any substantive significance in interpreting the Agreement.
        <b>
          Company may modify the terms of this Agreement at any time by posting
          new terms to its web site. End User may notify Company in writing
          within 30-days of such change that End User does not wish to accept
          the new terms. In the absence of such written non-acceptance
          notification within the 30-day period, End User confirms acceptance of
          the new terms by continuing to use the NGO Offerings and any
          Clearinghouse Services or other services specifically made available
          to you by Client.
        </b>
        If End User does not accept the new terms by notifying Company within
        the 30-day period, then End User may continue to use the NGO Offerings
        and any Clearinghouse Services or other services specifically made
        available to you by Client under End User’s existing terms until the end
        of the then current month.
      </Typography>
      <Typography variant="h6" style={{ margin: "10px 0", padding: "5px" }}>
        <strong>18. DEFINITIONS. </strong>
        {"\t"}

        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.1 "Affiliated Organization" </strong>
          {"\t"}
          means a company, practice, group and/or other legal entity (including
          those having separate tax identification numbers) of a Client located
          within the United States (and pre-identified, in writing, by Client to
          Company prior to their use of any Products or Services) that has
          entered into a written agreement with Client that binds it and its End
          Users to comply with the applicable terms of this Master Agreement and
          are either: (i) owned by Client; or (ii) in which Client has a
          majority controlling interest in such company, practice, group and/or
          other legal entity; or (iii) in which Client has entered into a
          management agreement with such company, practice and/or other legal
          entity that creates a bona fide business relationship with Client to
          perform one or more management service functions
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.2 “Analytics Database” </strong>
          {"\t"}
          means a data collection derived from De-Identified Data.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.3 . “Company Technology” </strong>
          {"\t"}
          means the Products, Services and User Materials, including all
          Interfaces, templates, forms, software tools, algorithms, software (in
          source code and object code forms), user interface designs,
          architecture, toolkits, plug-ins, objects, documentation, network
          designs, ideas, processes, know-how, methodologies, formulas, systems,
          data, heuristics, designs, inventions, techniques, trade secrets, and
          any related intellectual property rights throughout the world included
          therein, as well as any derivatives, modifications, improvements,
          enhancements, or extensions of the above, whenever developed.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.4 “Confidential Information” </strong>
          {"\t"}
          means a Discloser’s non-public information (including copies,
          summaries, and extracts):
          <br />
          (A) that is identified in writing as confidential at the time of
          disclosure, whether in printed, textual, graphic, or electronic form;
          or
          <br />
          (B) that is disclosed in non-tangible form, identified as confidential
          at the time of disclosure, summarized in a writing labeled as
          “confidential”, and delivered to Recipient within 15 days after
          disclosure. Confidential Information of Company includes the terms of
          the Master Agreement, this Agreement, Company Technology, customer
          and/or partner lists, and employee lists whether marked or identified
          as confidential. The Party disclosing Confidential Information is
          referred to as “Discloser” and the Party receiving Confidential
          Information is referred to as “Recipient”. Confidential Information
          does not include information that:
          <br /> a. is or becomes generally publicly available at or after the
          time of disclosure through no fault of either Recipient;
          <br /> b. was known to Recipient free of any confidentiality
          obligations, before its disclosure by Discloser;
          <br /> c. becomes known to Recipient free of any confidentiality
          obligations from a source other than Discloser; or
          <br />
          d.is independently developed by either Recipient without use of
          Confidential Information.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.5 “De-Identify” or “De-Identified” </strong>
          {"\t"}
          means to de-identify personal data in accordance with the “safe
          harbor” requirements of section 164.514(b)(2) of the HIPAA
          regulations, or in a manner that otherwise meets the requirements of
          section 164.514.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.6 "De-Identified Data" </strong>
          {"\t"}
          means personal data that has been De-Identified.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.7 "End Users" </strong>
          {"\t"}
          means Personnel who are: (A) based in the United States and (B)
          authorized by Client or an Affiliated Organization to use any portion
          of the Products or Services or (C) an authorized member of a community
          using the Software for purposes of health information exchange or care
          coordination. Unless specifically stated otherwise in the applicable
          User Material, each End User will be assigned a unique ID and
          password.{" "}
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>"18.8 Feedback" </strong>
          {"\t"}
          means any comments, submissions or other feedback End User may provide
          to Company directly or through Client, at its sole discretion,
          concerning the functionality and performance of the Company
          Technology, including identification of potential errors and
          improvements.{" "}
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.9 "Government Payer Programs" </strong>
          {"\t"}
          means, collectively, any federal health care or insurance program or
          any form of state Medicaid or other health care or insurance program{" "}
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.10 "Law" </strong>
          {"\t"}
          means those applicable federal and state statutes, regulations, codes,
          ordinances, agency directives, binding court orders and other binding
          government requirements
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.11 "Personnel" </strong>
          {"\t"}
          means certain, if any, locally installed software necessary for End
          User to access and use the NGO Offering. “Plug-in Software” is Company
          Software
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.12 "Plug-in Software </strong>
          {"\t"}
          means personal data that has been De-Identified.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.13 "Products" </strong>
          {"\t"} means one or more of the following procured by Client from
          Company for End User’s use and access as set out in an Order Form:
          Company Software, Third Party Software, Content, Company Hardware, and
          Third-Party Hardware.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.14 "Service" </strong>
          {"\t"} means each service procured by Client from Company under one or
          more Order Forms, including Implementation Services, Software
          Maintenance Services, Hardware Maintenance Services, Consulting
          Services, eLearning services, Hosting Services and SaaS as such terms
          are defined in the applicable Schedule.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.15 "Software" </strong>
          {"\t"} means Company Software and Third Party Software
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.16 "Special Program " </strong>
          {"\t"} means one or more of the following procured by Client from
          Company for End User’s use and access as set out in an Order Form:
          Company Software, Third Party Software, Content, Company Hardware, and
          Third-Party Hardware.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.17 "System " </strong>
          {"\t"} means collectively, the Company Software, appropriate Third
          Party database software, operating system software, Third Party
          Materials and other hardware, software and items described in an
          applicable Statement of Work functioning together as a single system.
        </Typography>
        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.16 "User Materials" </strong>
          {"\t"} means generally available documentation provided by Company
          relating to the general released versions of Products and Services,
          including user guides, technical manuals, release notes, installation
          instructions, information pertaining to maintenance services and
          online help files regarding use of Software, and all updates thereto.
        </Typography>

        <Typography
          variant="body1"
          style={{ margin: "10px 0", padding: "5px" }}
        >
          <strong>18.17 "Virus" </strong>
          {"\t"} means viruses, worms, and other malware or malicious code
          intended to cause or that cause computers or systems to fail to act
          properly or to function in an unintended manner or permit unintended
          access to such computers or systems by any Third Party. License keys
          and other functionality intentionally inserted in Software by the
          licensor are not Viruses.
        </Typography>
      </Typography>
    </Container>
  );
};

export default TermsAndCondition;
